// extracted by mini-css-extract-plugin
export default {"tags":"commentVideoDetail_tags__t8uyq","commentTitle":"commentVideoDetail_commentTitle__L2T8y"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"tags\":\"commentVideoDetail_tags__t8uyq\",\"commentTitle\":\"commentVideoDetail_commentTitle__L2T8y\"}";
        // 1793760840514
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  